// extracted by mini-css-extract-plugin
export default {"tokenomics_row":"Tokenomic_tokenomics_row__REFUh"};